import useGlobalStore from '@/store/useGlobalStore'
import React, { useRef } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import T from '../Helpers/Translate'

type Props = {
  text: string
  textColor?: string | null
  backgroundColor?: string | null
  className?: string
  iconComponent?: LucideIcon
}

export const AnnouncementBanner = ({
  text,
  textColor,
  backgroundColor,
  className,
  iconComponent: IconComponent,
}: Props) => {
  const textRef = useRef<HTMLSpanElement>(null)

  const {
    app: { alpha3, language },
  } = useGlobalStore()

  return (
    <div
      className={cn(
        'flex  justify-center overflow-hidden bg-primary p-2 text-white',

        className,
      )}
      style={{
        backgroundColor: backgroundColor ?? undefined,
        color: textColor ?? undefined,
      }}
    >
      <span className="inline  max-w-[90%]" ref={textRef}>
        {IconComponent && <IconComponent className="mr-2 inline" />}

        <span
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
        <span className="ml-2">
          <a href={`/${alpha3}/${language}/account/subscriptions`}>
            <T>announcement_link_text</T>{' '}
          </a>
        </span>
      </span>
    </div>
  )
}
